<template>
  <el-dialog
    :title="isEdit ? '编辑分类' : '新增分类'"
    :visible.sync="visible"
    width="500px"
    :close-on-click-modal="false"
    @closed="handleClosed"
  >
    <el-form ref="form" :model="form" :rules="rules" label-width="80px">
      <el-form-item label="分类名称" prop="name">
        <el-input v-model="form.name" placeholder="请输入分类名称" />
      </el-form-item>
      <el-form-item label="描述" prop="description">
        <el-input
          v-model="form.description"
          type="textarea"
          :rows="3"
          placeholder="请输入描述"
        />
      </el-form-item>
      <el-form-item label="排序" prop="sortOrder">
        <el-input-number v-model="form.sortOrder" :min="0" style="width: 100%;" />
      </el-form-item>
      <el-form-item label="状态" prop="status" v-if="isEdit">
        <el-radio-group v-model="form.status">
          <el-radio :label="1">启用</el-radio>
          <el-radio :label="0">禁用</el-radio>
        </el-radio-group>
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button @click="visible = false">取 消</el-button>
      <el-button type="primary" :loading="submitting" @click="handleSubmit">
        确 定
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import { createCategory, updateCategory } from '@/api/category'

export default {
  name: 'CategoryForm',
  data() {
    return {
      visible: false,
      isEdit: false,
      editingId: null,
      submitting: false,
      form: {
        name: '',
        description: '',
        sortOrder: 0,
        status: 1
      },
      rules: {
        name: [{ required: true, message: '请输入分类名称', trigger: 'blur' }]
      }
    }
  },
  methods: {
    open(row) {
      this.visible = true
      if (row) {
        this.isEdit = true
        this.editingId = row.id
        this.form = {
          name: row.name || '',
          description: row.description || '',
          sortOrder: row.sortOrder != null ? row.sortOrder : 0,
          status: row.status != null ? row.status : 1
        }
      } else {
        this.isEdit = false
        this.editingId = null
        this.form = {
          name: '',
          description: '',
          sortOrder: 0,
          status: 1
        }
      }
    },
    handleClosed() {
      this.$refs.form && this.$refs.form.resetFields()
      this.form = {
        name: '',
        description: '',
        sortOrder: 0,
        status: 1
      }
    },
    handleSubmit() {
      this.$refs.form.validate(async valid => {
        if (!valid) return
        this.submitting = true
        try {
          if (this.isEdit) {
            await updateCategory(this.editingId, this.form)
            this.$message.success('更新成功')
          } else {
            await createCategory(this.form)
            this.$message.success('创建成功')
          }
          this.visible = false
          this.$emit('saved')
        } catch (e) {
          console.error(e)
        } finally {
          this.submitting = false
        }
      })
    }
  }
}
</script>
